import type { State } from '../../typings'
import type { OpenDetailsPayload } from './typings'

export const openDetailsProducer = (
  state: State,
  payload: OpenDetailsPayload,
): State => ({
  ...state,
  content: payload.component,
  current: payload.id,
})
